import { Assignment, AssignmentType } from './Assignment';
import { CourseSection } from './CourseSection';
import { Enrollment } from './Enrollment';
import { Item } from './Item';
import { Person } from './Person';
import { Product } from './Product';
import { QuestionDescriptor } from './QuestionDescriptor';

export interface LearningObjectGrade {
  loId: number;
  name: string;
  grade: number;
  answerCount: number;
  isComplete: boolean;
}

export enum GradeItemType {
  QUESTION = 'QUESTION',
  FLASHCARD = 'FLASHCARD',
  SELFSTUDY = 'SELFSTUDY',
}

export interface AssignmentTutor {
  loGrades: LearningObjectGrade[];
}

export interface ChoiceOrder {
  originalOrder: number;
  displayOrder: number;
}

export interface AttemptOrder {
  type: GradeItemType;
  id: number;
  answerId?: number;
}

export enum DiscussionAttemptStatus {
  FLAGGED = 'FLAGGED',
  GRADED = 'GRADED',
  PARTIAL = 'PARTIAL',
}

// TEMPORARY DISCUSSION ATTEMPT INTERFACE
export type DiscussionAttempt = {
  person: Person;
} & Discussions &
  Item;

export interface Discussions {
  grade: number;
  responseCount: number;
  replyCount: number;
  accuracyGrade: number;
  accuracyRiskComment: string;
  aiRiskPenalty: number;
  aiRiskComment: string;
  plagiarismRiskPenalty: number;
  plagiarismRiskComment: string;
  repliesPenalty: number;
  gradeStatus: DiscussionAttemptStatus;
}

export interface AssignmentAttempt extends Item {
  productId: number;
  product?: Product;

  courseSectionId: number;
  courseSection?: CourseSection;

  assignmentId: number;
  assignment?: Assignment;

  enrollmentId: number;
  enrollment?: Enrollment;

  personId: number;
  person?: Person;

  type: AssignmentType;

  attemptNumber?: number;

  questionIds: number[];

  questionDescriptors: QuestionDescriptor[];

  expirationDate: string;

  isSubmitted?: boolean;

  grade: number;

  unsubmittedAnswers: string[];

  score: number;
  numberOfCorrectAnswers: number;
  numberOfIncorrectAnswers: number;

  choiceOrder: ChoiceOrder[][];

  isComplete: boolean;
  discussions?: Discussions;
  tutorResponseCount?: number;

  tutors?: AssignmentTutor;
}

export const isActiveAttempt = (attempt: AssignmentAttempt) => {
  const isTimeLimited =
    attempt.type === AssignmentType.QUIZ || attempt.type === AssignmentType.TEST;
  const isExpired =
    isTimeLimited && !!attempt.expirationDate && new Date(attempt.expirationDate) < new Date();

  return attempt.isActive && !attempt.isComplete && !attempt.isSubmitted && !isExpired;
};
